import { render, staticRenderFns } from "./UnfulfilledOrdersPage.vue?vue&type=template&id=8906f6ea&scoped=true"
import script from "./UnfulfilledOrdersPage.vue?vue&type=script&lang=js"
export * from "./UnfulfilledOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./UnfulfilledOrdersPage.vue?vue&type=style&index=0&id=8906f6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8906f6ea",
  null
  
)

export default component.exports